<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Categorías de Productos</h1>
      </div>
    </div>
    <div class="content__row">
      <category-list :filters="filters"></category-list>
      <category-view
        :category="category"
        v-if="categoryAction === 'view' && category"
      ></category-view>
      <category-edit
        @new="newCategory"
        :category="category"
        v-if="categoryAction === 'edit'"
        :key="key"
      ></category-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Navegación</h2>
          <router-link
            class="btn btn__action btn--small"
            :to="{ name: 'productView' }"
            >Productos</router-link
          >
          <h2 class="content__subtitle">Filtro</h2>
          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input
              type="text"
              name="search"
              id="search"
              class="form__input"
              v-model="search"
              @keyup="setFilters"
            />
          </div>

          <div class="form__container">
            <label class="form__label form__label--required" for="status_id"
              >Filtrar por estatus</label
            >
            <div class="form__select-container">
              <select
                name="status_id"
                id="status_id"
                class="form__select"
                v-model="status_id"
                @change="setFilters"
              >
                <option hidden :value="null">Selecciona un estatus</option>
                <option
                  v-for="(status, index) in category_status"
                  :key="index"
                  :value="status.id"
                  v-text="status.name"
                ></option>
              </select>
            </div>
          </div>

          <div class="form__container">
            <label class="form__label form__label--required" for="parentId"
              >Filtrar por categoría principal</label
            >
            <div class="form__select-container">
              <select
                name="parentId"
                id="parentId"
                class="form__select"
                v-model="parentId"
                @change="setFilters"
              >
                <option :value="null">Todas las categorías</option>
                <option
                  v-for="(category, index) in parents"
                  :key="index"
                  :value="category.id"
                  v-text="category.title_es"
                ></option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newCategory" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from "@/core/api/request";
import categoryList from "./list";
import categoryView from "./view";
import categoryEdit from "./edit";
import Mixins from "./mixins";
import { category_status } from "./mocks";
export default {
  mixins: [httpService, Mixins],
  components: {
    categoryList,
    categoryView,
    categoryEdit
  },
  data: function() {
    return {
      category_status: category_status,
      key: 0,
      search: null,
      status_id: null,
      filters: undefined,
      categoryAction: null,
      category: null,
      parentId: null
    };
  },
  created: function() {
    this.getParentCategories();
  },
  mounted: function() {
    this.$on("view", id => {
      this.getCategory(id, "view");
    });
    this.$on("edit", id => {
      this.getCategory(id, "edit");
    });
  },
  methods: {
    setFilters: function() {
      let filter = "";
      if (this.search && this.search.length > 1) {
        filter = filter + "&search=" + this.search;
      }
      if (this.status_id) {
        filter = filter + "&status_id=eq:" + this.status_id;
      }
      if (this.parentId) {
        filter = filter + "&parent_id=eq:" + this.parentId;
      }
      filter = filter.replace(/(^&+|&+$)/, "");
      if (filter.length > 0) {
        this.filters = filter;
      } else {
        this.filters = undefined;
      }
    },
    getCategory: function(id, action) {
      this.categoryAction = action;
      let httpRequest = {
        params: "",
        module: "product_categories"
      };
      this.getById(id, httpRequest).then(category => {
        this.category = category.data;
      });
    },
    newCategory: function() {
      this.category = undefined;
      this.key = ++this.key;
      this.categoryAction = "edit";
    }
  }
};
</script>

<style lang="sass">
@import "../../assets/sass/components/_home"
@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/product_categories/categories.vue